import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "store"
import type { IUserGroup } from "types/userGroupTypes"

interface UserGroupState {
  userGroups: Array<IUserGroup>
}

const initialState: UserGroupState = {
  userGroups: [] as IUserGroup[],
}

export const userGroupSlice = createSlice({
  name: "usergroup",
  initialState,
  reducers: {
    setUserGroups: (state, action: PayloadAction<Array<IUserGroup>>) => {
      state.userGroups = action.payload
    },
    addUserGroup: (state, action: PayloadAction<IUserGroup>) => {
      state.userGroups?.push(action.payload)
    },
    updateUserGroup: (state, action: PayloadAction<IUserGroup>) => {
      var index = state.userGroups.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.userGroups[index] = action.payload
      }
    },
    removeUserGroup: (state, action: PayloadAction<IUserGroup>) => {
      var index = state.userGroups.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.userGroups.splice(index, 1)
      }
    },
    resetUserGroup: (state, _action) => {
      state.userGroups = []
    },
  },
})

export const { setUserGroups, addUserGroup, updateUserGroup, removeUserGroup, resetUserGroup } =
  userGroupSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectCount = (state: RootState) => state.usergroup

export default userGroupSlice.reducer
